var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered",class:{'is-hidden': !_vm.active}},[_c('font-awesome-icon',{attrs:{"icon":"spinner","size":"3x","spin":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }